import { setCMSBarWidth } from './cms-bar-width'
import { appendVersions } from './site-common'

document.addEventListener('DOMContentLoaded', () => {

    const structure = document.querySelector('.cms-toolbar-item-cms-mode-switcher > a:not(.cms-btn-disabled)')
    if (structure) {
        structure.addEventListener('click', () => {setTimeout(setCMSBarWidth, 1000)}, true)
    }

    appendVersions(document.querySelector('.cms-toolbar-item-logo a'))
})
